import * as Sentry from '@sentry/vue'

export const sentryCaptureError = (err: any, extras = {}) => {
  const errorCode = err?.response?.data?.errorCode
  if (errorCode) {
    Sentry.withScope(scope => {
      scope.setExtras({ errorCode })
      // keep the original error type add the error code to the message
      const updatedError = Object.assign(err, {
        message: `${err.message} - ${errorCode}`,
      })
      Sentry.captureException(updatedError, { extra: extras })
    })
  } else {
    Sentry.captureException(err)
  }
}
